import { render, staticRenderFns } from "./AuthNotFound.vue?vue&type=template&id=137031ef&scoped=true&"
import script from "./AuthNotFound.vue?vue&type=script&lang=ts&"
export * from "./AuthNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./AuthNotFound.vue?vue&type=style&index=0&id=137031ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137031ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
